import { useDeleteHttp } from "../../http.hook";

export function useRemoveProposalSocialAdminHttp() {
  return useDeleteHttp<null, null>({
    path: "/admin/campaigns/proposals/:proposalId/socials/:socialId",
  });
}
